const israeliPhoneNumberRegex = /^(9725\d{8}|05\d{8})$/;
const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

const sumDigits = (n: number) => {
  return (--n % 9) + 1;
};

export const isValidIsraeliId = (id: string) => {
  if (id.length !== 9 || !/^\d+$/.test(id)) {
    return false;
  }

  id = id.padStart(9, '0');

  const weighted_digits: number[] = Array.from(id).map((digit, i) => {
    const multiplier = i % 2 === 0 ? 1 : 2;
    const product = parseInt(digit, 10) * multiplier;
    return product <= 9 ? product : sumDigits(product);
  });

  return weighted_digits.reduce((acc, val) => acc + val, 0) % 10 === 0;
};

export const isValidPhoneNumber = (phoneNumber: string) => {
  const cleanedPhoneNumber = phoneNumber.replace(/[\s\-+]/g, '');
  return israeliPhoneNumberRegex.test(cleanedPhoneNumber);
};

export const isValidEmail = (email: string) => {
  return emailRegex.test(email);
};
